import API from "./api";

// 1. Contact Us
export const sendContactMessage = async (payload) => {
  try {
    const response = await API.post("website/contact-us", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 2. Career List
export const getCareerList = async (payload) => {
  try {
    const response = await API.post("website/career", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 3. Apply Job
export const applyJob = async (formData) => {
  try {
    const response = await API.post(
      "website/apply-job", // endpoint
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // IMPORTANT for file upload
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 4. FAQ List
export const getFaqList = async (payload) => {
  try {
    const response = await API.post("website/faq", payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 5. Check Rolo User Account
export const checkRoloAccount = async (payload) => {
  try {
    const response = await API.post(
      "website/check-account",
      payload
    );


    return response.data;
    console.log("checkRoloAccount response:", response.data); // Log the response data
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 6. Send Delete Account OTP
export const sendDeleteAccountOtp = async (payload) => {
  try {
    const response = await API.post(
      "website/delete-account-send-otp",
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// 7. Delete Account
export const deleteRoloAccount = async (payload) => {
  try {
    const response = await API.post(
      "website/delete-account",
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};